import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import useSendAnalyticScrollPositions from '../../hooks/useSendAnalyticScrollPositions';
import * as S from './styled';

const SubMenu = ({ header, items, style, children }) => {
  const elementRef = useRef();
  useSendAnalyticScrollPositions(elementRef, 'hubmenu');

  return (
    <S.SubMenu style={style} ref={elementRef}>
      <div>
        {children}
        {header}
        <S.SubMenuList>
          {items.map((item) => (
            <li key={item.title}>
              <S.SubMenuLink href={item.link}>{item.title}</S.SubMenuLink>
            </li>
          ))}
        </S.SubMenuList>
      </div>
    </S.SubMenu>
  );
};

SubMenu.propTypes = {
  children: PropTypes.node,
  header: PropTypes.node,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  // Empty shape, because `style` is a bit arbitrary.
  style: PropTypes.shape({}),
};

SubMenu.defaultProps = {
  children: null,
  header: null,
  items: [],
  style: {},
};

export default SubMenu;
